import { useEffect, useState } from 'react';
import api from '../api';
import { resolveMediaUrl } from '../utils/url';

export default function AdminShops() {
  const [items, setItems] = useState([]);
  const [users, setUsers] = useState([]);
  const systems = [
    'Shopify','WooCommerce','Magento','PrestaShop','BigCommerce','Shopware','Wix eCommerce','Squarespace Commerce','OpenCart','osCommerce','Drupal Commerce','JTL-Shop','Oxid eShop','Ecwid','Salesforce Commerce Cloud','SAP Commerce Cloud','Adobe Commerce (Magento)','VTEX','commercetools','HCL Commerce','Shopify Plus','WooCommerce + WordPress','Anderes...'
  ];
  const [form, setForm] = useState({ name:'', url:'', logoUrl:'', description:'', order:100, active:true, userId:'', categories:'', tags:'', badge:'', system:'', systemCustom:'' });
  const [edit, setEdit] = useState(null);

  const load = async ()=>{
    const res = await api.get('/shops/admin').then(r=>r.data.items||[]);
    setItems(res);
    const us = await api.get('/users/list/shop-owners').then(r=>r.data.items||[]);
    setUsers(us);
  };
  useEffect(()=>{ load(); }, []);

  const submit = async (e)=>{
    e.preventDefault();
    const payload = { ...form, order: Number(form.order)||100 };
    if (edit) await api.put(`/shops/admin/${edit.id}`, payload);
    else await api.post('/shops/admin', payload);
    setForm({ name:'', url:'', logoUrl:'', description:'', order:100, active:true, userId:'', categories:'', tags:'', badge:'', system:'', systemCustom:'' });
    setEdit(null);
    await load();
  };
  const del = async (it)=>{
    if (!confirm('Shop löschen?')) return;
    await api.delete(`/shops/admin/${it.id}`);
    await load();
  };

  return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Shops verwalten</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Öffentlich sichtbare Shop-Links pflegen.</p>
      </section>
      <section style={{ width:'100%', maxWidth:1100, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        <form onSubmit={submit} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12, marginBottom:12 }}>
          <div style={{ display:'grid', gap:8 }}>
            <label>
              <div style={{ fontSize:12, color:'#bbb' }}>Name</div>
              <input required value={form.name} onChange={e=>setForm({ ...form, name:e.target.value })} />
            </label>
            <label>
              <div style={{ fontSize:12, color:'#bbb' }}>URL</div>
              <input required value={form.url} onChange={e=>setForm({ ...form, url:e.target.value })} placeholder="https://…" />
            </label>
            <label>
              <div style={{ fontSize:12, color:'#bbb' }}>Logo-URL (optional)</div>
              <input value={form.logoUrl} onChange={e=>setForm({ ...form, logoUrl:e.target.value })} placeholder="https://…/logo.png" />
            </label>
            <label>
              <div style={{ fontSize:12, color:'#bbb' }}>Beschreibung (optional)</div>
              <textarea value={form.description} onChange={e=>setForm({ ...form, description:e.target.value })} />
            </label>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Kategorien (Komma-getrennt)</div>
                <input value={form.categories} onChange={e=>setForm({ ...form, categories:e.target.value })} placeholder="gaming, hardware" />
              </label>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Tags (Komma-getrennt)</div>
                <input value={form.tags} onChange={e=>setForm({ ...form, tags:e.target.value })} placeholder="sale, rabatt" />
              </label>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Badge (optional)</div>
                <input value={form.badge} onChange={e=>setForm({ ...form, badge:e.target.value })} placeholder="Neu, Partner, -10%" />
              </label>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Shopsystem</div>
                <select value={form.system} onChange={e=>setForm({ ...form, system:e.target.value })}>
                  <option value="">(keine Angabe)</option>
                  {['Shopify','WooCommerce','Magento','PrestaShop','BigCommerce','Shopware','Wix eCommerce','Squarespace Commerce','OpenCart','osCommerce','Drupal Commerce','JTL-Shop','Oxid eShop','Ecwid','Salesforce Commerce Cloud','SAP Commerce Cloud','Adobe Commerce (Magento)','VTEX','commercetools','HCL Commerce','Shopify Plus','WooCommerce + WordPress','Anderes...'].map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </label>
            </div>
            {form.system === 'Anderes...' && (
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Individuelles Shopsystem</div>
                <input value={form.systemCustom} onChange={e=>setForm({ ...form, systemCustom:e.target.value })} placeholder="Name des Systems" />
              </label>
            )}
            <label>
              <div style={{ fontSize:12, color:'#bbb' }}>Verantwortliches Mitglied (Owner)</div>
              <select value={form.userId} onChange={e=>setForm({ ...form, userId: e.target.value })}>
                <option value="">(kein Besitzer)</option>
                {users.map(u => <option key={u.id} value={u.id}>{u.displayName || u.username}</option>)}
              </select>
            </label>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Reihenfolge</div>
                <input type="number" value={form.order} onChange={e=>setForm({ ...form, order:e.target.value })} />
              </label>
              <label>
                <div style={{ fontSize:12, color:'#bbb' }}>Aktiv</div>
                <input type="checkbox" checked={form.active} onChange={e=>setForm({ ...form, active:e.target.checked })} />
              </label>
            </div>
            <div>
              <button type="submit">{edit ? 'Shop aktualisieren' : 'Shop anlegen'}</button>
              {edit && <button type="button" onClick={()=>{ setEdit(null); setForm({ name:'', url:'', logoUrl:'', description:'', order:100, active:true, userId:'', categories:'', tags:'', badge:'', system:'', systemCustom:'' }); }} style={{ marginLeft:8 }}>Abbrechen</button>}
            </div>
          </div>
        </form>

        <ul>
          {items.map(it => (
            <li key={it.id} style={{ background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:10, padding:12, marginBottom:10 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, justifyContent:'space-between' }}>
                <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                  {it.logoUrl ? <img src={it.logoUrl} alt="" style={{ width:36, height:36, objectFit:'contain' }} /> : <div style={{ width:36, height:36, borderRadius:8, background:'#222', display:'flex', alignItems:'center', justifyContent:'center' }}>{it.name?.[0]?.toUpperCase()||'S'}</div>}
                  <div>
                    <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                      <b>{it.name}</b>
                      {it.badge && <span style={{ fontSize:12, padding:'2px 8px', borderRadius:999, background:'#2e7d32' }}>{it.badge}</span>}
                      <span style={{ color: it.active ? '#8bc34a' : '#f44336' }}>· {it.active ? 'aktiv' : 'inaktiv'}</span>
                      {it.system && <span style={{ fontSize:12, color:'#bbb' }}>· {it.system === 'Anderes...' ? (it.systemCustom || 'Individuell') : it.system}</span>}
                      {typeof it.clicks === 'number' && <span style={{ fontSize:12, color:'#bbb' }}>· Klicks: {it.clicks}</span>}
                    </div>
                    <div style={{ fontSize:12, color:'#bbb' }}>{it.url}</div>
                    <div style={{ fontSize:12, color:'#bbb', marginTop:4 }}>
                      {(it.categories||[]).map(c => <span key={c} style={{ marginRight:6, border:'1px solid rgba(255,255,255,0.15)', borderRadius:12, padding:'2px 6px', fontSize:11 }}>#{c}</span>)}
                      {(it.tags||[]).map(t => <span key={t} style={{ marginRight:6, border:'1px dashed rgba(255,255,255,0.15)', borderRadius:12, padding:'2px 6px', fontSize:11 }}>#{t}</span>)}
                    </div>
                  </div>
                </div>
                <div style={{ display:'flex', gap:16, alignItems:'center' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:8 }} title="Besitzer">
                    <img src={resolveMediaUrl(it.owner?.avatarUrl || '/avatars/default-avatar.png')} alt="" style={{ width:28, height:28, borderRadius:'50%', objectFit:'cover' }} />
                    <span style={{ fontSize:12, color:'#bbb' }}>{it.owner?.displayName || it.owner?.username || '—'}</span>
                  </div>
                  <div style={{ display:'flex', gap:8 }}>
                    <button onClick={()=>{ setEdit(it); setForm({ name:it.name||'', url:it.url||'', logoUrl:it.logoUrl||'', description:it.description||'', order:it.order||100, active:!!it.active, userId:it.userId||'', categories:(it.categories||[]).join(', '), tags:(it.tags||[]).join(', '), badge:it.badge||'', system:it.system||'', systemCustom:it.systemCustom||'' }); }}>Bearbeiten</button>
                    <button onClick={()=>del(it)} style={{ color:'red' }}>Löschen</button>
                  </div>
                </div>
              </div>
            </li>
          ))}
          {items.length === 0 && <li style={{ color:'#aaa' }}>Keine Shops vorhanden.</li>}
        </ul>
      </section>
    </div>
  );
}
